import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const EditchannelAdminApi = createAsyncThunk(
  "auth/EditchannelAdmin",
  async (data, { rejectWithValue }) => {
    console.log(data)
    try {
      const response = await AuthAxios.patch(apiRoutes.channelAdminAction("status", 1, data.id, 1), data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }

const EditchannelAdminSlice = createSlice({
  name: "Edit channelAdmin",
  initialState: intialState,
  reducers: {
    resetchannelAdmin: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(EditchannelAdminApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(EditchannelAdminApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results;
      state.message = action?.payload?.message;
    });
    builder.addCase(EditchannelAdminApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetchannelAdmin } = EditchannelAdminSlice.actions;
export const EditchannelAdminreducer = EditchannelAdminSlice.reducer;
